import Model from './Model';

export default class MembershipIntegration extends Model {
  resource() {
    return 'membership_integration';
  }
}
